<div class="mx-auto" [style.max-width]="!isBigAmountOfCategories ? '200px' : ''">
    <a [routerLink]="['/products', 'category', category.slug] | localize" (click)="onCategoryClick(category.slug)">
        <div class="item" [class.item-not-browser]="!isBrowser">
            <img class="img-fluid" [src]="category.image.url" alt="" />
            <span class="d-block text-center fs-15 fw-700 font-secondary text-secondary showcase">{{ category.name | translate }}</span>
        </div>
    </a>
</div>
